// @ts-nocheck: converted from JS

import { default as Groups } from '@/components/Studies/Groups/Groups';

export default Groups;
